<template>
	<div :style="style.container">
		<div v-if="open" :style="style.toggles">
			<div v-for="toggle in toggles" @click="select(toggle)" :key="toggle.wording" :style="toggle.active ? toggleHighlightStyle : style.toggle">
				<div :style=" {border: toggle.active ? 'none' : '1px solid ' + toggle.color ,backgroundColor: activeCandidatesId.includes(toggle.code) ? toggle.color : 'white', color: activeCandidatesId.includes(toggle.code) ? 'white' : toggle.color , position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', paddingTop: '3px' }" >
					{{toggle.wording}}
				</div>
			</div>
			<div v-for="i in 4" :key="'filler' + i" :style="toggleFillerStyle">
			</div>
		</div>
		<div :style="style.showHide" @click="open = !open">
			<template v-if="open">
				Masquer&nbsp;&nbsp;▼
			</template>
			<template v-else>
				Sélectionner les candidats&nbsp;&nbsp;▲
			</template>
		</div>
	</div>
</template>
<script>
	export default {
		name: 'Toggles',
		props: {
			candidates: {
				type: Array,
				required: true,
			},
			activeCandidatesId: {
				type: Array,
				required: true,
			}
		},
		data: function() {
			return {
				open: false,
				style: {
					container: {
						position: 'fixed',
						bottom: 0,
						left:0,
						height: 'auto',
						backgroundColor: 'white',
						width: '100%',
						padding: '.8em .5em',
						border: '1px solid hsl(0 ,0% ,85%)',
						boxShadow: '0 -1px 4px rgba(0,0,0,0.16), 0 -1px 4px rgba(0,0,0,0.23)',
						zIndex: 2,
					},
					showHide: {
						fontFamily: 'adelle-sans, sans',
						fontSize:  '1em',
						textAlign: 'center',
						textTransform: 'uppercase', 
						color: '#4A4A4A',
					},
					toggles: {
						width: 'calc(100% + 8px)',
						display: 'flex',
						flexWrap: 'wrap',
						zIndex: 99,
						margin: '0 -4px 15px',
					},
					toggle: {
						color: '#222',
						flex: '1 1 100px',
						flexWrap: 'wrap',
						textAlign: 'center',
						margin: '8px 4px',
						position: 'relative',
						fontWeight: '400',
						fontSize:  '.9em',
						lineHeight: '100%',
						fontFamily: 'adelle-sans, sans',
						height: '24px',
					}
				}
			}
		},
		computed: {
			toggles: function() {
				return this.candidates.reduce((agg, candidate) => {
					return agg.concat( {code: candidate.id , wording: candidate.last_name, color: candidate.party_color, active: candidate.show } ) 
				}, [])
			},
			toggleHighlightStyle: function() {
				let style = {}
				for (let key in this.style.toggle) {
					if (key != 'opacity') style[key] = this.style.toggle[key]
				}

				return style
			},
			toggleFillerStyle: function() {
				let style = {}
				for (let key in this.style.toggle) {
					style[key] = this.style.toggle[key]
				}
				style['marginBottom'] = '0px !important'
				style['marginTop'] = '0px !important'
				style['paddingTop'] = '0px !important'
				style['paddingBottom'] = '0px !important'
				style['height'] = '0px !important'

				return style
			}
		},
		methods: {
			select: function(toggle) {
				this.$emit('change', toggle.code)
			} 
		}
	}
</script>
<style lang="scss">

</style>